import usePageTitle from "hooks/usePageTitle";
import RecordIdCard from "routes/ui_sandbox/RecordIdCard";
import useRecordIdParam from "routes/ui_sandbox/useRecordIdParam";
import CampaignFormLoader from "routes/ui_sandbox/pages/CampaignFormLoader";

const CampaignFormPage = () => {
  usePageTitle("Campaign Form");
  const { id, setId, clearId } = useRecordIdParam();

  return (
    <>
      <RecordIdCard
        label="Campaign ID"
        description="Leave empty to create a campaign, or load an id to edit one."
        id={id}
        onLoad={setId}
        onClear={clearId}
      />
      {/* A create switches to editing the saved campaign. */}
      <CampaignFormLoader
        key={id}
        id={id}
        onSaved={saved => setId(saved?.id ?? id)}
        onCancel={clearId}
      />
    </>
  );
};

export default CampaignFormPage;
